// extracted by mini-css-extract-plugin
export default {"textInput":"styles_textInput__yRsZi"};